module.exports = __webpack_public_path__ + "img/toplogoe.aa91b831.jpg";